export default "__VITE_ASSET__DsfkAANo__"